import styled, { css } from 'styled-components';

import Input, { Sizes } from '../../../Input';

export const StyledInput = styled(Input)<{ size: Sizes }>`
  &:not(:last-child) {
    ${({ size }) => {
      switch (size) {
        case Sizes.small:
          return css`
            margin-bottom: 14px;
          `;
        case Sizes.medium:
          return css`
            margin-bottom: 24px;
          `;
        default:
          return css`
            margin-bottom: 24px;
          `;
      }
    }}
  }
`;
